
import { Modal, Table } from "react-bootstrap";
import CardContenedorAdmin from "../components/CardContenedorAdmin";
import useNotificaciones from "../hooks/useNotificaciones";
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import ReadButton from "../components/ReadButton";
import { useEmpleadoStore } from "../stores/useEmpleadoStore";
import Cargando from "../components/Cargando";


export default function Notificaciones() {

    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const { notificaciones, handleClose, handleShow, show, setIdEmpleadoNotificacion, notificacionesIndividuales,
        limpiarNotificaciones, leerTodas, leyendoTodas, cargando: varCargando, cargandoNotificaciones
    } = useNotificaciones()

    if (!objLogueado.permitido) {
        window.location = "/"
        return (<></>)
    }

    const ListGroupItemCustom = () => {
        return notificaciones.map((e, i) => {
            return (
                <tr key={i}>
                    <td>{e.nombre_empleado}</td>
                    <td>{e.ultima_actualizacion}</td>
                    <td>
                        <Button variant="link" onClick={ ()  => {
                            setIdEmpleadoNotificacion( e.pk_empleado );
                            handleShow()
                        }}>Ver todas</Button>
                        { e.cantidad ? <Badge bg="primary" pill>
                            {e.cantidad}
                        </Badge> : '' }
                    </td>
                </tr>
            )
        })
    }


    return (
        <CardContenedorAdmin ruta='notificaciones'>

            <p className="lead">Notificaciones</p>

            { varCargando && <Cargando cargando={varCargando} /> }

            <Table>
                <thead>
                    <tr>
                        <th>Empleado</th>
                        <th>Última actualización</th>
                        <th>Empleado</th>
                    </tr>
                </thead>
                <tbody><ListGroupItemCustom /></tbody>
            </Table>


            <Modal show={show} onHide={handleClose} size="lg" onExited={ limpiarNotificaciones }>
                <Modal.Header closeButton>
                    <Modal.Title>{ notificacionesIndividuales.nombre_empleado ? `Actualizaciones de ${notificacionesIndividuales.nombre_empleado}` : 'Actualizaciones' }</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <div className="d-flex justify-content-between mb-3">
                        <Button disabled={ leyendoTodas } variant="link" onClick={ leerTodas }>Marcar todas como leídas</Button>
                        <Cargando cargando={cargandoNotificaciones} />
                    </div>

                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Actividad</th>
                                <th>Fecha</th>
                                <th>Marcar como leída</th>
                            </tr>
                        </thead>
                        <tbody>
                            { notificacionesIndividuales?.map( (n, i) => (
                                <tr key={i} className={ n.leida ? '' : 'table-secondary' }>
                                    <td>{ n.mensaje }</td>
                                    <td>{ n.fecha }</td>
                                    <td className="text-center">
                                        <ReadButton id={n.id} />
                                    </td>
                                </tr>
                            ) ) }
                        </tbody>
                    </Table>

                </Modal.Body>


                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>


        </CardContenedorAdmin>
    )
}

